
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Notification } from '@/common/Notifications';
import Modal from './Base3.vue';

@Component({
	components: {
		Modal,
	},
})
export default class NotificationModal extends Vue {
	@Prop() private notification: Notification;
	@Prop() private markDeleted: any;
	@Prop() private selectedNotifications: any;
}
